import { Dictionary } from '../../utils/types'

export const OTHER_OPTION = 'OTHR'

export enum DomainType {
  Country = 'Country',
  Culture = 'Culture',
  CustomerRequestStatus = 'CustomerRequestStatus',
  DeliveryOption = 'DeliveryOption',
  ReportAvailability = 'ReportAvailability',
  State = 'State',
  Town = 'Town',
  PaymentMethod = 'PaymentMethod',
  OrderStatus = 'OrderStatus',
  Role = 'Role',
  Office = 'Office',
  OrderSource = 'OrderSource'
}

export type DomainData = {
  code: string
  description: string
  [key: string]: unknown
}

export type Domain = DomainData[] | null

export type State = {
  code: string
  description: string
  countryCode: string
}

export type Town = {
  code: string
  description: string
  stateCode?: string
}

export type LocalizedDomainData = {
  domains: Partial<Record<DomainType, Domain>>
  states: Dictionary<State[]>
  towns: Dictionary<Town[]>
}

export type DomainState = { data: Dictionary<LocalizedDomainData> }
